/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PropertyOutGeography
 */
export interface PropertyOutGeography {
    /**
     * 
     * @type {number}
     * @memberof PropertyOutGeography
     */
    geographyId: number;
    /**
     * 
     * @type {number}
     * @memberof PropertyOutGeography
     */
    propertyId: number;
    /**
     * 
     * @type {Date}
     * @memberof PropertyOutGeography
     */
    modificationDate: Date;
}

export function PropertyOutGeographyFromJSON(json: any): PropertyOutGeography {
    return PropertyOutGeographyFromJSONTyped(json, false);
}

export function PropertyOutGeographyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PropertyOutGeography {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'geographyId': json['geographyId'],
        'propertyId': json['propertyId'],
        'modificationDate': (new Date(json['modificationDate'])),
    };
}

export function PropertyOutGeographyToJSON(value?: PropertyOutGeography | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'geographyId': value.geographyId,
        'propertyId': value.propertyId,
        'modificationDate': (value.modificationDate.toISOString()),
    };
}


